import Vue from 'vue';
import App from './App.vue';
import VueYandexMetrika from 'vue-yandex-metrika';
import router from './lib/router';
import store from './lib/store';
import i18n from './lib/i18n';
import firebase from './lib/firebase';
// @ts-ignore
import VueYoutube from 'vue-youtube';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import './lib/vue-imask';

Vue.config.productionTip = false;
Vue.prototype.$analytics = firebase.analytics();
Vue.use(VueYoutube);
Vue.use(VueYandexMetrika, {
  id: 93767949,
  router: router,
  env: process.env.NODE_ENV,
  options: {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: true,
  },
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
